import React from "react";
import { APP_VERSION } from "../version";

export function Footer() {
  return (
    <footer 
      className="bg-[var(--theme-footer-bg)] text-[var(--theme-footer-text)] font-[family:var(--theme-font-family-body)] text-[14px] py-[var(--theme-spacing-xl)] px-[var(--theme-spacing-2xl)] flex items-center justify-between flex-wrap gap-[var(--theme-spacing-sm)] w-full box-border"
      aria-label="Site footer"
    >
      <span className="font-semibold text-[var(--theme-footer-text)]">
        Bhaktivedanta Model School, Pune
      </span>
      <span className="opacity-80 text-[var(--theme-footer-text)]">
        Copyright &copy; {new Date().getFullYear()}
      </span>
      <span className="opacity-60 italic text-[var(--theme-footer-text)]">
        Internal use only
      </span>
      <span 
        className="opacity-70 border border-[var(--theme-footer-text)]/20 bg-[var(--theme-footer-text)]/5 text-[var(--theme-footer-text)] px-2 py-0.5 rounded text-[12px] font-mono"
        title="App version (auto-generated at build time)"
      >
        v{APP_VERSION}
      </span>
    </footer>
  );
}

export default Footer;
